import { Component } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.scss'],
  standalone: true,
  imports: [],
})
export class ProgressBarComponent {}
